import '../styles/pages/page.scss'
import '../styles/pages/character.scss'
import { useState } from 'react'

const Characters = () => {

    const [modal, isModalOpen] = useState(false)

    return (
        <div className="page-container">
            <div className={`character-modal ${ modal ? 'visible' : 'invisible'}`}>
                <div className="character-modal-wrapper">
                    <Customization/>
                    <button className="character-modal-close" onClick={()=>isModalOpen(false)}>
                        Close
                    </button>
                </div>
            </div>
            <div className="main-container">
                <h1 className="main-title">
                    Characters
                </h1>
                <h1 className="main-header">
                    Those Lost in the Dark
                </h1>
                <div className="character-pair">
                    <img src={`${process.env.PUBLIC_URL}/img/character/img_char_01.png`} alt="Protaganist" className="character-title" />
                    <div className="character-text">
                        <img src={`${process.env.PUBLIC_URL}/img/character/protaganist.png`} alt="Mysterioius Older Girl" className="character-title" />
                        <p className="character-desc">
                            A young girl who ventured into the darkened streets of her town at night in search of her missing <span className="blue">memories</span>. She must find them all before dawn in order to break a <span className="blue">curse</span> that's been placed on her.
                        </p>
                        <p className="character-desc">
                            Her missing memories take the form of <span className="blue">mementos from her past</span>. Once she recovers one, the <span className="blue">memory</span> associated with it will come flooding back.
                        </p>
                        <h1 className="character-open" onClick={()=>{
                            isModalOpen(true)
                        }}>
                            *The protagonist's appearance can be customized.
                        </h1>
                    </div>
                </div>
                <div className="character-pair">
                    <img src={`${process.env.PUBLIC_URL}/img/character/img_char_02.png`} alt="Mysterioius Older Girl" className="character-title" />
                    <div className="character-text">
                        <img src={`${process.env.PUBLIC_URL}/img/character/mog.png`} alt="Mysterioius Older Girl" className="character-title" style={{maxWidth: '300px'}}/>
                        <p className="character-desc">
                            A girl who is a few years older than the protagonist and often appears in her lost memories.
                        </p>
                        <p className="character-desc">
                            She seems to be wandering the streets of the town as well in search of <span className="blue">something</span>, though she won't say what exactly.
                        </p>
                        <p className="character-desc">
                            She carries a large <span className="blue">camera</span> with her.
                        </p>
                    </div>
                </div>
                <div className="character-pair">
                    <img src={`${process.env.PUBLIC_URL}/img/character/img_char_03.png`} alt="Mugi" className="character-title" />
                    <div className="character-text">
                        <img src={`${process.env.PUBLIC_URL}/img/character/mugi.png`} alt="Mysterioius Older Girl" className="character-title" />
                        <p className="character-desc">
                            A fluffy, white <span className="blue">cat</span> that belongs to the protagonist.
                        </p>
                        <p className="character-desc">
                            Mugi is especially attached to the protagonist and will often follow her around.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Customization = () => {
    return (
        <div className="customization-container">
            <div className="character-images">
                <img src={`${process.env.PUBLIC_URL}/img/character/custom-1.png`} alt="Customization Option" />
                <img src={`${process.env.PUBLIC_URL}/img/character/custom-2.png`} alt="Customization Option" />
                <img src={`${process.env.PUBLIC_URL}/img/character/custom-3.png`} alt="Customization Option" />
            </div>
            <h2 className="character-mini">
                You can choose 6 different aspects of your character to customize, including hairstyle, hair color, clothing, and accessories.
            </h2>
        </div>
    )
}

export default Characters;